import { hashHistory as browserHistory } from 'react-router';

import { flagService } from './flagService';
import * as orderApiServices from './orderApiServices';
import * as paymentApiServices from './paymentApiServices';
import * as payPalClient from './paypalServices';
import * as storageServices from './storageServices';
import * as storeApiServices from './storeApiServices';
import * as stripeClient from './stripeServices';
import * as userApiServices from './userApiServices';

export const history = browserHistory;

export {
  flagService,
  orderApiServices,
  paymentApiServices,
  storageServices,
  storeApiServices,
  userApiServices,
};

export { payPalClient, stripeClient };
